import { render, staticRenderFns } from "./BankDetailsForm.vue?vue&type=template&id=58d9ec9b&scoped=true"
import script from "./BankDetailsForm.vue?vue&type=script&lang=js"
export * from "./BankDetailsForm.vue?vue&type=script&lang=js"
import style0 from "./BankDetailsForm.vue?vue&type=style&index=0&id=58d9ec9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d9ec9b",
  null
  
)

export default component.exports